import modal from "./modal"

export const Modal = modal